import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { productsJsmAiGovernanceNativeAiCapabilitiesRoute } from '@jira/router-routes__products-jsm-ai-governance-native-ai-capabilities-routes/src/productsJsmAiGovernanceNativeAiCapabilitiesRoute.tsx';
import { productJsmAiGovernanceEntryPoint } from '@jira/spa-apps__admin-pages-product-jsm-ai-governance/src/productJsmAiGovernanceEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({ main: productJsmAiGovernanceEntryPoint });

export const productsJsmAiGovernanceNativeAiCapabilitiesRouteEntry: Route = createEntry(
	productsJsmAiGovernanceNativeAiCapabilitiesRoute,
	() => ({
		group: 'global-settings',
		entryPoint: () =>
			fg('enable-jsm-native-app-ai-capabilities') ? entryPoint : notFoundPageEntrypoint,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: fg('enable-jsm-native-app-ai-capabilities')
			? [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()]
			: getNavigationResources(),
		ufoName: 'admin.jsm-rovo-ai-ai-controls',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
